export interface ArticleContent {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  date: string;
  tags: string[];
  description: string;
  content: string;
  director: string;
  cast: string[];
  year: string;
  region: string;
}

export const articleData: Record<string, ArticleContent> = {
  v1: {
    id: 'v1',
    title: '流浪地球3：星辰大海',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20astronauts%20in%20space%2C%20distant%20galaxy%2C%20dramatic%20lighting%2C%20cinematic%20widescreen%20composition%2C%20warm%20orange%20and%20deep%20space%20contrast%2C%20movie%20poster%20quality%2C%20professional%20film%20photography&width=800&height=450&seq=douhua-v1-detail&orientation=landscape',
    duration: '128分钟',
    views: 8932000,
    rating: 9.2,
    date: '2026-07-15',
    tags: ['科幻', '冒险', '国产大片'],
    description: '在浩瀚的宇宙中，人类文明的命运再次悬于一线。面对未知的星际威胁，一支勇敢的探险队踏上了拯救地球的壮丽征程。《流浪地球3》延续了前作的宏大世界观，以更加震撼的视觉特效和更加深刻的主题思考，为观众呈现了一场超越想象的科幻盛宴。',
    content: `《流浪地球3：星辰大海》是中国科幻电影的又一里程碑之作。影片延续了前两部的宏大叙事，将故事推向了一个全新的高度。

在上一部中，地球成功脱离了木星引力危机，继续在宇宙中漂泊。然而，新的威胁悄然而至——一支来自未知星系的外星文明探测到了地球的轨迹，人类面临着前所未有的生存危机。

影片以三条主线展开：地面上的科学团队试图与外星文明建立沟通；空间站上的宇航员们执行着一项危险的外交任务；而普通民众则在巨大的不确定性中寻找生存的意义。

导演以惊人的视觉想象力，构建了一个既真实又充满诗意的未来世界。从冰封的地球表面到璀璨的星际空间，每一帧画面都充满了令人窒息的美丽。影片的特效制作达到了国际顶级水准，尤其是在展现星际尺度的场景时，给观众带来了强烈的视觉冲击和情感共鸣。

演员阵容方面，实力派演员的加盟为影片注入了强大的表演力量。他们塑造的角色有血有肉，在面对宏大命运时的挣扎与抉择令人动容。影片不仅仅是视觉上的震撼，更是一部关于人性、勇气和希望的深刻作品。

《流浪地球3》不仅是一部优秀的科幻电影，更是中国电影工业进步的象征。它向世界展示了中国电影人的创造力和技术实力，也为中国科幻电影的未来开辟了更加广阔的可能性。`,
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '王智', '宁理'],
    year: '2026',
    region: '中国大陆',
  },
  v2: {
    id: 'v2',
    title: '山河令：江湖再起',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20scene%20with%20ancient%20warriors%20in%20traditional%20costumes%2C%20misty%20mountains%2C%20bamboo%20forest%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20professional%20film%20photography&width=800&height=450&seq=douhua-v2-detail&orientation=landscape',
    duration: '45集',
    views: 12560000,
    rating: 9.5,
    date: '2026-06-20',
    tags: ['武侠', '古装', '热门剧集'],
    description: '一段跨越江湖恩怨的传奇故事，两个命运交织的灵魂在乱世中寻找真相与救赎。《山河令：江湖再起》以精良的制作、扣人心弦的剧情和出色的演员表演，成为年度最受瞩目的古装武侠剧。',
    content: `《山河令：江湖再起》是近年来最受期待的古装武侠剧之一。该剧以架空的古代江湖为背景，讲述了两位身世迥异的主角在乱世中相遇、相知、相守的传奇故事。

故事发生在一个群雄割据的时代，江湖各派势力明争暗斗。主角周子舒是一位身负血海深仇的剑客，他隐姓埋名，在江湖中寻找当年的真相。而温客行则是一个神秘组织的少主，表面玩世不恭，内心却藏着不为人知的秘密。

两人因一场意外相遇，从此命运交织在一起。在追寻真相的过程中，他们揭开了当年一场惊天阴谋的面纱，也发现了彼此之间深藏的联系。江湖的恩怨情仇、国家的兴衰存亡，都在这场波澜壮阔的故事中徐徐展开。

该剧的制作水准堪称一流。精致的服装设计还原了古代华服之美，考究的场景布置营造出浓郁的古典氛围。武打场面的设计更是精妙绝伦——既有传统武侠的飘逸灵动，又融入了现代动作美学的力量感。

演员的表演也是该剧的一大亮点。主演将角色的性格层次和情感变化诠释得淋漓尽致，配角演员同样贡献了可圈可点的表演。整部剧的节奏把控得当，情节推进张弛有度，让观众在45集的篇幅中始终保持着高度的观剧热情。`,
    director: '李木戈',
    cast: ['张哲瀚', '龚俊', '周也', '马闻远', '孙浠伦'],
    year: '2026',
    region: '中国大陆',
  },
  v3: {
    id: 'v3',
    title: '欢乐喜剧人2026',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20stage%20with%20colorful%20lights%2C%20performers%20on%20stage%2C%20audience%20laughing%2C%20bright%20warm%20stage%20lighting%2C%20entertainment%20show%20photography&width=800&height=450&seq=douhua-v3-detail&orientation=landscape',
    duration: '90分钟',
    views: 6710000,
    rating: 8.8,
    date: '2026-08-01',
    tags: ['喜剧', '综艺', '搞笑'],
    description: '全国顶尖喜剧人齐聚一堂，带来最爆笑的原创喜剧作品。《欢乐喜剧人2026》以全新的赛制和更强大的嘉宾阵容，为观众带来了前所未有的欢乐体验。',
    content: `《欢乐喜剧人2026》是这档国民喜剧综艺的最新一季。本季节目在保留经典赛制的基础上，进行了全面的创新升级，为观众带来了更加丰富多彩的喜剧表演。

本季节目汇聚了来自全国各地的顶尖喜剧人才，包括知名喜剧演员、新生代笑星以及跨界嘉宾。他们在舞台上通过小品、相声、脱口秀、即兴喜剧等多种形式，展现了当代中国喜剧的多元魅力。

节目的一大亮点是全新的"喜剧挑战赛"环节。在这一环节中，选手需要在限定的时间内，根据现场给出的主题进行即兴创作和表演。这不仅考验选手的喜剧功底，更考验他们的创意能力和临场反应。

舞台设计方面，本季采用了全新的沉浸式舞美方案。高科技的灯光和投影技术为每一个作品创造了独特的视觉氛围，让喜剧表演的感染力得到了极大的提升。

除了精彩的舞台表演，节目还深入挖掘了喜剧人背后的故事。通过幕后花絮和访谈环节，观众可以看到这些喜剧人在生活中的真实状态，感受到他们对喜剧艺术的热爱和执着。

《欢乐喜剧人2026》不仅是一档娱乐节目，更是一个展示中国喜剧力量的平台。它为喜剧创作者提供了展示才华的舞台，也为观众带来了无数欢乐和感动的瞬间。`,
    director: '施嘉宁',
    cast: ['沈腾', '贾玲', '岳云鹏', '杨迪', '金靖'],
    year: '2026',
    region: '中国大陆',
  },
  v4: {
    id: 'v4',
    title: '舌尖上的中国·新篇章',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20noodles%20in%20traditional%20kitchen%2C%20warm%20natural%20light%2C%20steam%20rising%2C%20rustic%20atmosphere%2C%20professional%20food%20photography&width=800&height=450&seq=douhua-v4-detail&orientation=landscape',
    duration: '52分钟',
    views: 4520000,
    rating: 9.7,
    date: '2026-05-10',
    tags: ['美食', '纪录片', '人文'],
    description: '跟随镜头探寻中国各地最地道的美食，感受食物背后的人文故事与匠心传承。《舌尖上的中国·新篇章》以全新的视角和更深入的人文关怀，续写了这部经典美食纪录片的传奇。',
    content: `《舌尖上的中国·新篇章》是中国最受欢迎的美食纪录片系列的最新力作。这一季的节目在延续前作高品质制作的基础上，以更加深入的视角和更加丰富的内容，为观众呈现了一场视觉与味觉的双重盛宴。

本季节目横跨中国三十余个省市，记录了超过一百种地方特色美食的制作过程。从东北的酸菜炖粉条到云南的过桥米线，从新疆的烤羊肉串到广东的早茶点心，每一道美食都承载着一方水土的文化记忆。

与以往不同的是，本季更加注重食物背后的人物故事。镜头对准了那些默默坚守传统手艺的普通人——有传承了五代的面点师傅，有守护着百年老卤的卤味传人，也有在大山深处种植着独特食材的农民。他们用自己的双手，守护着中国饮食文化的根脉。

在摄影和制作方面，本季采用了最新的超高清拍摄技术。特写镜头下，食材的纹理、汤汁的沸腾、蒸汽的升腾都被捕捉得极为细腻，让观众仿佛能够闻到食物的香气。配乐方面同样精心制作，传统乐器与现代配乐的融合，为每一个美食故事增添了独特的韵味。

《舌尖上的中国·新篇章》不仅是一部美食纪录片，更是一部关于中国文化的深情告白。它让我们看到了美食背后的人间烟火，感受到了食物所承载的情感与记忆。`,
    director: '陈晓卿',
    cast: ['李立宏（旁白）'],
    year: '2026',
    region: '中国大陆',
  },
  v5: {
    id: 'v5',
    title: '斗罗大陆：魂师传说',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20fantasy%20scene%20with%20young%20hero%20in%20magical%20landscape%2C%20glowing%20spirit%20energy%2C%20epic%20battle%20stance%2C%20vibrant%20colors%2C%20anime%20art%20style&width=800&height=450&seq=douhua-v5-detail&orientation=landscape',
    duration: '25分钟/集',
    views: 21300000,
    rating: 9.3,
    date: '2026-07-28',
    tags: ['国漫', '热血', '玄幻'],
    description: '在武魂的世界里，少年唐三凭借坚韧不拔的意志，一步步成长为最强魂师。《斗罗大陆：魂师传说》以精美的画面和热血的剧情，成为国漫的标杆之作。',
    content: `《斗罗大陆：魂师传说》改编自唐家三少的同名小说，是近年来最受欢迎的国产动画作品之一。这部动画以一个充满武魂和魂技的奇幻世界为背景，讲述了少年唐三的成长故事。

在这个世界中，每个人在六岁时都会觉醒属于自己的武魂。武魂的种类千奇百怪，有兽武魂、器武魂、食物武魂等等。唐三觉醒的武魂是一株看似普通的蓝银草，但他却拥有着非凡的天赋和坚韧的意志。

故事从唐三进入史莱克学院开始。在这里，他遇到了一群志同道合的伙伴——小舞、戴沐白、奥斯卡、马红俊、宁荣荣和朱竹清。七人组成了"史莱克七怪"，在学院老师和彼此的帮助下，不断提升自己的实力。

动画的制作质量令人惊叹。人物设计精致而有辨识度，战斗场景的动作流畅度和特效表现力都达到了国际一流水平。尤其是在魂技释放的场景中，绚丽的特效和富有创意的视觉表现在国产动画中独树一帜。

除了精彩的战斗场面，动画在情感刻画方面同样出色。唐三与小舞之间纯真的感情、七怪之间的深厚友谊、师徒之间的传道授业，都让这部作品不仅是一部热血动画，更是一部充满温度的故事。

《斗罗大陆：魂师传说》的成功，标志着中国动画产业已经具备了制作世界级作品的能力，也为国产动画的未来发展指明了方向。`,
    director: '沈乐平',
    cast: ['赵乾景（唐三）', '秦紫翼（小舞）'],
    year: '2026',
    region: '中国大陆',
  },
};